    <button [class]="cssClass" class="ml-2 p-grid"
            alt="Ir para o topo" title="Ir para o topo"
            pTooltip="Ir para o topo" tooltipPosition="top" style="color: white; background: #5776b0; border:0px;">
        <i class="pi pi-angle-up text-color-white p-col p-py-0 p-px-2" style="font-size: 2.5rem;"></i>
    </button>
